<template>
  <div id="paginaRiepilogoIncassiBiglietteria">
    <!-- Elementi Pagina----------------------------------------------------------------------------------- -->
    <b-row class="match-height">
      <!-- Card Elenco DropdownList: -->
      <b-col xl="12" md="12">
        <b-card tag="article" class="mb-2">
          <b-card-header class="align-items-baseline">
            <div>
              <b-card-title>Riepilogo Incassi Biglietteria</b-card-title>
              <b-card-text class="mb-0"> Teatro Coccia </b-card-text>
            </div>
            <!-- dropdown menù laterale dx -->
            <b-dropdown
              variant="link"
              no-caret
              right
              class="chart-dropdown"
              toggle-class="p-0"
            >
              <template #button-content>
                <feather-icon
                  icon="MoreVerticalIcon"
                  size="18"
                  class="text-body cursor-pointer"
                />
              </template>
              <b-dropdown-item href="#"> ... </b-dropdown-item>
            </b-dropdown>
          </b-card-header>
          <b-card-body class="mb-0">
            <!-- card body -->
            <b-row>
              <!-- Input di tipo dropdown collegato: annoCorrente  -->
              <b-col xl="12" md="12" class="pt-1">
                <ejs-dropdownlist
                  id="dropAnni"
                  ref="dropAnni"
                  :query="queryAnni"
                  :dataSource="anniData"
                  :index="anniIndex"
                  :fields="anniFields"
                  :change="onAnnoChange"
                  v-model="annoCorrente"
                  placeholder="Seleziona un Anno"
                ></ejs-dropdownlist>
              </b-col>
              <!-- Input di tipo dropdown collegato: meseCorrente  -->
              <b-col xl="12" md="12" class="pt-1">
                <ejs-dropdownlist
                  id="dropMesi"
                  ref="dropMesi"
                  :query="queryMesi"
                  :dataSource="mesiData"
                  :index="mesiIndex"
                  :fields="mesiFields"
                  :enabled="dropMesiEnabled"
                  :change="onMeseChange"
                  placeholder="Seleziona un Mese"
                  v-model="meseCorrente"
                ></ejs-dropdownlist>
              </b-col>
              <!-- Riga vuota per spaziatura -->
              <b-col xl="12" md="12" class="pt-1"></b-col>
              <!-- Input di tipo alert per messaggi gridA  -->
              <b-col xl="12" md="12" class="pt-1">
                <b-alert
                  :show="alertADismissCountDown"
                  dismissible
                  variant="warning"
                  @dismissed="alertADismissCountDown = 0"
                  @dismiss-count-down="alertACountDownChanged"
                >
                  <p>Occorre selezionare una riga della tabella</p>
                  <b-progress
                    variant="warning"
                    :max="alertADismissSecs"
                    :value="alertADismissCountDown"
                    height="4px"
                  />
                </b-alert>
              </b-col>

              <b-col xl="12" md="12" class="pt-1">
                <!-- Input di tipo grid: incassiBiglFullData  -->
                <div id="GridParent">
                  <ejs-grid
                    id="gridA"
                    ref="gridA"
                    :dataSource="incassiBiglFullData"
                    :allowSorting="true"
                    :toolbarClick="gridAClickHandler"
                    :toolbar="gridA.toolbarOptions"
                    :height="gridA.height"
                    :allowFiltering="true"
                    :filterSettings="gridA.filterOptions"
                    :editSettings="gridA.editOptions"
                    :queryCellInfo="gridAqueryCellInfo"
                    :sortSettings="gridA.sortOptions"
                  >
                    <e-columns>
                      <e-column
                        field="id"
                        headerText="ID"
                        :isPrimaryKey="true"
                        width="60"
                      ></e-column>
                      <e-column
                        field="data"
                        headerText="Data"
                        :format="settings.formatoData"
                        type="date"
                        width="150"
                      ></e-column>
                      <e-column
                        field="stato"
                        headerText="Stato"
                        width="200"
                        editType="dropdownedit"
                        :edit="editparams"
                      ></e-column>
                      <e-column
                        field="statoEsporta"
                        headerText="Esportazione"
                        width="200"
                        editType="dropdownedit"
                        :edit="editparams"
                      ></e-column>
                      <e-column
                        field="TitoliDiaccesso"
                        headerText="Titoli di Accesso"
                        width="200"
                      ></e-column>
                      <e-column
                        field="Biglietti"
                        headerText="di cui Biglietti"
                        width="200"
                      ></e-column>
                      <e-column
                        field="Abbonamenti"
                        headerText="di cui Abbonamenti"
                        width="200"
                      ></e-column>
                      <e-column
                        field="e_GiftCard_VoucherIncasso"
                        headerText="e-Gift Card/Voucher"
                        width="200"
                      ></e-column>
                      <e-column
                        field="ContanteInCassaforte"
                        headerText="Contante in Cassaforte"
                        width="200"
                      ></e-column>
                      <e-column
                        field="CartaDiCredito"
                        headerText="Carta di Credito"
                        width="200"
                      ></e-column>
                      <e-column
                        field="Bancomat"
                        headerText="Bancomat"
                        width="200"
                      ></e-column>
                      <e-column
                        field="PayPal"
                        headerText="Paypal"
                        width="200"
                      ></e-column>
                      <e-column
                        field="Satispay"
                        headerText="Satispay"
                        width="200"
                      ></e-column>
                      <e-column
                        field="Bonifico"
                        headerText="Bonifico"
                        width="200"
                      ></e-column>
                      <e-column
                        field="BonificoOrganizzatori"
                        headerText="Bonifico Organizzatori"
                        width="200"
                      ></e-column>
                      <e-column
                        field="Assegno"
                        headerText="Assegno"
                        width="200"
                      ></e-column>
                      <e-column
                        field="e_GiftCard_Voucher"
                        headerText="e-Gift Card/Voucher"
                        width="200"
                      ></e-column>
                      <e-column
                        field="ImportoeGiftCardScadute"
                        headerText="e-Gift Card Scadute"
                        width="200"
                      ></e-column>
                      <e-column
                        field="I18app"
                        headerText="18app"
                        width="200"
                      ></e-column>
                      <e-column
                        field="CartaDelDocente"
                        headerText="Carta del Docente"
                        width="200"
                      ></e-column>
                      <e-column
                        field="CartaCulturaMerito"
                        headerText="Carta Cultura e del Merito"
                        width="250"
                      ></e-column>
                      <e-column
                        field="OnlineTotale"
                        headerText="On-line Totale"
                        width="200"
                      ></e-column>
                      <e-column
                        field="CCPNexi"
                        headerText="On-line Nexi"
                        width="200"
                      ></e-column>
                      <e-column
                        field="CCPPayPal"
                        headerText="On-line Paypal"
                        width="200"
                      ></e-column>
                      <!-- <e-column field="RidottoOspiti" headerText="Ridotto Ospiti" width="200"></e-column> -->
                      <e-column
                        field="PrestampaTitoli"
                        headerText="Prestampa Titoli"
                        width="200"
                      ></e-column>
                      <e-column
                        field="Amministrativo"
                        headerText="Amministrativo"
                        width="200"
                      ></e-column>
                      <!-- <e-column field="prelieviBiglietteria" headerText="Prelievi da Biglietteria"
                        width="200"></e-column> -->
                      <e-column
                        field="Differenza"
                        headerText="Differenza"
                        width="200"
                      ></e-column>
                      <!-- <e-column field="progressivo" headerText="Progressivo contante+assegni in biglietteria"
                        width="200"></e-column>
                      <e-column field="versamento" headerText="Versamento contante + assegni in banca"
                        width="200"></e-column> -->
                      <e-column
                        field="Annotazione"
                        headerText="Annotazione"
                        width="300"
                      ></e-column>
                    </e-columns>

                    <e-aggregates>
                      <e-aggregate>
                        <e-columns>
                          <e-column
                            type="Sum"
                            field="TitoliDiaccesso"
                            format="€ ######.##"
                          ></e-column>
                          <e-column type="Sum" field="Biglietti" format="€ ######.##"></e-column>
                          <e-column type="Sum" field="Abbonamenti" format="€ ######.##"></e-column>
                          <e-column
                            type="Sum"
                            field="e_GiftCard_VoucherIncasso"
                            format="€ ######.##"
                          ></e-column>
                          <e-column
                            type="Sum"
                            field="ContanteInCassaforte"
                            format="€ ######.##"
                          ></e-column>
                          <e-column
                            type="Sum"
                            field="CartaDiCredito"
                            format="€ ######.##"
                          ></e-column>
                          <e-column type="Sum" field="Bancomat" format="€ ######.##"></e-column>
                          <e-column type="Sum" field="PayPal" format="€ ######.##"></e-column>
                          <e-column type="Sum" field="Satispay" format="€ ######.##"></e-column>
                          <e-column type="Sum" field="Bonifico" format="€ ######.##"></e-column>
                          <e-column type="Sum" field="BonificoOrganizzatori" format="€ ######.##"></e-column>
                          <e-column type="Sum" field="Assegno" format="€ ######.##"></e-column>
                          <e-column
                            type="Sum"
                            field="e_GiftCard_Voucher"
                            format="€ ######.##"
                          ></e-column>
                          <e-column
                            type="Sum"
                            field="ImportoeGiftCardScadute"
                            format="€ ######.##"
                          ></e-column>
                          <e-column 
                            type="Sum" 
                            field="I18app"
                            format="€ ######.##"
                            ></e-column>
                          <e-column
                            type="Sum"
                            field="CartaDelDocente"
                            format="€ ######.##"
                          ></e-column>
                          <e-column
                            type="Sum"
                            field="CartaCulturaMerito"
                            format="€ ######.##"
                          ></e-column>
                          <e-column type="Sum" field="OnlineTotale" format="€ ######.##"></e-column>
                          <e-column type="Sum" field="CCPNexi" format="€ ######.##"></e-column>
                          <e-column type="Sum" field="CCPPayPal" format="€ ######.##"></e-column>
                          <e-column
                            type="Sum"
                            field="PrestampaTitoli"
                            format="€ ######.##"
                          ></e-column>
                          <e-column
                            type="Sum"
                            field="Amministrativo"
                            format="€ ######.##"
                          ></e-column>
                          <e-column type="Sum" field="Differenza" format="€ ######.##"></e-column>
                        </e-columns>
                      </e-aggregate>
                    </e-aggregates>
                  </ejs-grid>
                </div>
              </b-col>

              <!-- Button:  -->
              <b-col xl="12" md="12" class="mt-1">
                <ejs-button
                  id="generaTracciatiButton"
                  @click.native="generaTracciati()"
                  >Genera Tracciati Contabilità
                </ejs-button>
              </b-col>


              <b-col xl="12" md="12" class="mt-3">
                <h3>Riepilogo Incassi Biglietteria</h3>
              </b-col>


              <!-- Button:  -->
              <b-col xl="6" md="6" class="mt-1">
                <ejs-button id="aggiornaRiepilogoButton" @click.native="aggiornaRiepilogo()">Aggiorna Riepilogo</ejs-button>
              </b-col>
              <b-col xl="6" md="6" class="mt-1">
                <ejs-button id="scaricaRiepilogoButton" @click.native="scaricaRiepilogo()">Scarica Riepilogo</ejs-button>
              </b-col>


              <b-col xl="12" md="12" class="mt-1">

                <b-card tag="article" class="mb-2">
                  <b-card-header class="align-items-baseline">
                    <div>
                      <b-card-title>Totali</b-card-title>
                      <b-card-text class="mb-0" />
                    </div>
                  </b-card-header>
                  <b-card-body class="mb-0">
                    <!-- card body -->
                    <b-row>
                      <b-col xl="3" md="3" class="mb-2">
                        <label for="totalePreventivo" class="h5">Totale Preventivo</label>
                        <ejs-numerictextbox id="totalePreventivo" v-model="totalePreventivo
                  " floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="Preventivo"
                          showSpinButton="false" showClearButton="true" :readonly="true" />
                      </b-col>
                      <b-col xl="3" md="3" class="mb-2">
                        <label for="totaleConsuntivo" class="h5">TotaleConsuntivo</label>
                        <ejs-numerictextbox id="totaleConsuntivo" v-model="totaleConsuntivo
                  " floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="Consuntivo"
                          showSpinButton="false" showClearButton="true" :readonly="true" />
                      </b-col>
                      <b-col xl="3" md="3" class="mb-2">
                        <label for="scostamento" class="h5">Scostamento</label>
                        <ejs-numerictextbox id="scostamento" v-model="scostamento
                  " floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="Preventivo - Consuntivo"
                          showSpinButton="false" showClearButton="true" :readonly="true" />
                      </b-col>
                      <b-col xl="3" md="3" class="mb-2">
                        <label for="raggiungimentoPerc" class="h5">Raggiungimento %</label>
                        <ejs-numerictextbox id="raggiungimentoPerc" v-model="raggiungimentoPerc
                  " floatLabelType="Never" cssClass="" format="###.##" placeholder="Raggiungimento %"
                          showSpinButton="false" showClearButton="true" :readonly="true" />
                      </b-col>

                    </b-row>
                  </b-card-body>
                </b-card>

              </b-col>




            </b-row>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <!-- dialogA: dialogDettaglioRiga ---------------------------------------------------------------------------------------------------- -->
    <ejs-dialog
      id="dialogA"
      ref="dialogA"
      :header="dialogA.header"
      :buttons="dialogA.buttons"
      :visible="dialogA.visible"
      :showCloseIcon="dialogA.showCloseIcon"
      :close="dialogAClose"
      :open="dialogAOpen"
      :zIndex="dialogA.zIndex"
      :animationSettings="dialogA.animationSettings"
    >
      <b-tabs ref="tabAdialogA" v-model="dialogA.tabAdialogAIndex">
        <b-tab title="Dettaglio Riga">
          <b-row class="match-height">
            <!-- Card con Elementi Input: Informazioni Scrittura -->
            <b-col xl="12" md="12">
              <b-card tag="article" class="mb-2">
                <b-card-header class="align-items-baseline">
                  <div>
                    <b-card-title>Dettaglio riga</b-card-title>
                    <b-card-text class="mb-0" />
                  </div>
                </b-card-header>
                <b-card-body class="mb-0">
                  <b-row>
                    <b-col xl="2" md="2" class="mb-2">
                      <label for="data" class="h5">Data</label>
                      <ejs-datepicker
                        id="data"
                        v-model="incassiBiglActiveData.data"
                        :format="settings.formatoDatepicker"
                        :readonly="true"
                      />
                    </b-col>
                    <b-col xl="2" md="2" class="mb-2">
                      <label for="stato" class="h5">Stato</label>
                      <ejs-textbox
                        id="stato"
                        v-model="incassiBiglActiveData.stato"
                        floatLabelType="Never"
                        cssClass=""
                        showClearButton="true"
                        :readonly="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>
                    <b-col xl="2" md="2" class="mb-2">
                      <label for="statoEsporta" class="h5">Esportazione</label>
                      <ejs-textbox
                        id="statoEsporta"
                        v-model="incassiBiglActiveData.statoEsporta"
                        floatLabelType="Never"
                        cssClass=""
                        showClearButton="true"
                        :readonly="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col xl="2" md="2" class="mb-2">
                      <label for="TitoliDiaccesso" class="h5"
                        >Titoli di Accesso</label
                      >
                      <ejs-textbox
                        id="TitoliDiaccesso"
                        v-model="incassiBiglActiveData.TitoliDiaccesso"
                        floatLabelType="Never"
                        cssClass=""
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                        :readonly="true"
                      />
                    </b-col>
                    <b-col xl="2" md="2" class="mb-2">
                      <label for="Biglietti" class="h5">Biglietti</label>
                      <ejs-textbox
                        id="Biglietti"
                        v-model="incassiBiglActiveData.Biglietti"
                        floatLabelType="Never"
                        cssClass=""
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                        :readonly="true"
                      />
                    </b-col>
                    <b-col xl="2" md="2" class="mb-2">
                      <label for="Abbonamenti" class="h5">Abbonamenti</label>
                      <ejs-textbox
                        id="Abbonamenti"
                        v-model="incassiBiglActiveData.Abbonamenti"
                        floatLabelType="Never"
                        cssClass=""
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                        :readonly="true"
                      />
                    </b-col>
                    <b-col xl="2" md="2" class="mb-2">
                      <label for="e_GiftCard_VoucherIncasso" class="h5"
                        >Incasso e-GiftCard Voucher</label
                      >
                      <ejs-textbox
                        id="e_GiftCard_VoucherIncasso"
                        v-model="
                          incassiBiglActiveData.e_GiftCard_VoucherIncasso
                        "
                        floatLabelType="Never"
                        cssClass=""
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                        :readonly="true"
                      />
                    </b-col>
                  </b-row>
                  <b-row>
                    
                    <b-col xl="2" md="2" class="mb-2">
                      <label for="ContanteInCassaforte" class="h5"
                        >Contante In Cassaforte</label
                      >
                      <ejs-textbox
                        id="ContanteInCassaforte"
                        v-model="incassiBiglActiveData.ContanteInCassaforte"
                        floatLabelType="Never"
                        cssClass=""
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                        :change="onInputChange"
                      />
                    </b-col>
                    <b-col xl="2" md="2" class="mb-2">
                      <label for="CartaDiCredito" class="h5"
                        >Carta Di Credito</label
                      >
                      <ejs-textbox
                        id="CartaDiCredito"
                        v-model="incassiBiglActiveData.CartaDiCredito"
                        floatLabelType="Never"
                        cssClass=""
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                        :change="onInputChange"
                      />
                    </b-col>
                    <b-col xl="2" md="2" class="mb-2">
                      <label for="Bancomat" class="h5">Bancomat</label>
                      <ejs-textbox
                        id="Bancomat"
                        v-model="incassiBiglActiveData.Bancomat"
                        floatLabelType="Never"
                        cssClass=""
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                        :change="onInputChange"
                      />
                    </b-col>
                    <b-col xl="2" md="2" class="mb-2">
                      <label for="PayPal" class="h5">PayPal</label>
                      <ejs-textbox
                        id="PayPal"
                        v-model="incassiBiglActiveData.PayPal"
                        floatLabelType="Never"
                        cssClass=""
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                        :change="onInputChange"
                      />
                    </b-col>
                    <b-col xl="2" md="2" class="mb-2">
                      <label for="Satispay" class="h5">Satispay</label>
                      <ejs-textbox
                        id="Satispay"
                        v-model="incassiBiglActiveData.Satispay"
                        floatLabelType="Never"
                        cssClass=""
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                        :change="onInputChange"
                      />
                    </b-col>
                    <b-col xl="2" md="2" class="mb-2">
                      <label for="Bonifico" class="h5">Bonifico</label>
                      <ejs-textbox
                        id="Bonifico"
                        v-model="incassiBiglActiveData.Bonifico"
                        floatLabelType="Never"
                        cssClass=""
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                        :change="onInputChange"
                      />
                    </b-col>
                  </b-row>
                  <b-row>
                    
                    <b-col xl="2" md="2" class="mb-2">
                      <label for="Assegno" class="h5">Assegno</label>
                      <ejs-textbox
                        id="Assegno"
                        v-model="incassiBiglActiveData.Assegno"
                        floatLabelType="Never"
                        cssClass=""
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                        :change="onInputChange"
                      />
                    </b-col>
                    <b-col xl="2" md="2" class="mb-2">
                      <label for="e_GiftCard_Voucher" class="h5"
                        >Voucher e-GiftCard</label
                      >
                      <ejs-textbox
                        id="e_GiftCard_Voucher"
                        v-model="incassiBiglActiveData.e_GiftCard_Voucher"
                        floatLabelType="Never"
                        cssClass=""
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                        :change="onInputChange"
                      />
                    </b-col>
                    <b-col xl="2" md="2" class="mb-2">
                      <label for="ImportoeGiftCardScadute" class="h5"
                        >Importo Gift Card scadute</label
                      >
                      <ejs-textbox
                        id="ImportoeGiftCardScadute"
                        v-model="incassiBiglActiveData.ImportoeGiftCardScadute"
                        floatLabelType="Never"
                        cssClass=""
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                        :change="onInputChange"
                        :readonly="true"
                      />
                    </b-col>
                    <b-col xl="2" md="2" class="mb-2">
                      <label for="I18app" class="h5">18app</label>
                      <ejs-textbox
                        id="I18app"
                        v-model="incassiBiglActiveData.I18app"
                        floatLabelType="Never"
                        cssClass=""
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                        :change="onInputChange"
                      />
                    </b-col>
                    <b-col xl="2" md="2" class="mb-2">
                      <label for="PrestampaTitoli" class="h5"
                        >PrestampaTitoli</label
                      >
                      <ejs-textbox
                        id="PrestampaTitoli"
                        v-model="incassiBiglActiveData.PrestampaTitoli"
                        floatLabelType="Never"
                        cssClass=""
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                        :change="onInputChange"
                      />
                    </b-col>
                    <b-col xl="2" md="2" class="mb-2">
                      <label for="CartaDelDocente" class="h5"
                        >Carta del Docente</label
                      >
                      <ejs-textbox
                        id="CartaDelDocente"
                        v-model="incassiBiglActiveData.CartaDelDocente"
                        floatLabelType="Never"
                        cssClass=""
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                        :change="onInputChange"
                      />
                    </b-col>
                    <b-col xl="2" md="2" class="mb-2">
                      <label for="CartaCulturaMerito" class="h5"
                        >Carta Cultura e del Merito</label
                      >
                      <ejs-textbox
                        id="CartaCulturaMerito"
                        v-model="incassiBiglActiveData.CartaCulturaMerito"
                        floatLabelType="Never"
                        cssClass=""
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                        :change="onInputChange"
                      />
                    </b-col>
                    
                    <b-col xl="2" md="2" class="mb-2">
                      <label for="OnlineTotale" class="h5">Online totale</label>
                      <ejs-textbox
                        id="OnlineTotale"
                        v-model="incassiBiglActiveData.OnlineTotale"
                        floatLabelType="Never"
                        cssClass=""
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                        :change="onInputChange"
                      />
                    </b-col>
                    <b-col xl="2" md="2" class="mb-2">
                      <label for="CCPNexi" class="h5">On-line Nexi</label>
                      <ejs-textbox
                        id="CCPNexi"
                        v-model="incassiBiglActiveData.CCPNexi"
                        floatLabelType="Never"
                        cssClass=""
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                        :change="onInputChange"
                      />
                    </b-col>
                    <b-col xl="2" md="2" class="mb-2">
                      <label for="CCPPayPal" class="h5">On-line Paypal</label>
                      <ejs-textbox
                        id="CCPPayPal"
                        v-model="incassiBiglActiveData.CCPPayPal"
                        floatLabelType="Never"
                        cssClass=""
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                        :change="onInputChange"
                      />
                    </b-col>
                    
                    <b-col xl="2" md="2" class="mb-2">
                      <label for="Amministrativo" class="h5"
                        >Amministrativo</label
                      >
                      <ejs-textbox
                        id="Amministrativo"
                        v-model="incassiBiglActiveData.Amministrativo"
                        floatLabelType="Never"
                        cssClass=""
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                        :change="onInputChange"
                      />
                    </b-col>

                    <b-col xl="2" md="2" class="mb-2">
                      <label for="BonificoOrganizzatori" class="h5">Bonifico Organizzatori</label>
                      <ejs-textbox
                        id="BonificoOrganizzatori"
                        v-model="incassiBiglActiveData.BonificoOrganizzatori"
                        floatLabelType="Never"
                        cssClass=""
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                        :change="onInputChange"
                      />
                    </b-col>

                  </b-row>
                  <b-row>
                    <b-col xl="4" md="4" class="mb-2">
                      <label for="Differenza" class="h5">Differenza</label>
                      <ejs-textbox
                        id="Differenza"
                        v-model="incassiBiglActiveData.Differenza"
                        floatLabelType="Never"
                        cssClass=""
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                        :readonly="true"
                      />
                    </b-col>

                    <b-col xl="8" md="8" class="mb-2">
                      <label for="Annotazione" class="h5">Annotazione</label>
                      <ejs-textbox
                        id="Annotazione"
                        v-model="incassiBiglActiveData.Annotazione"
                        floatLabelType="Never"
                        cssClass=""
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col xl="12" md="12" class="text-right mt-1">
                      <ejs-button
                        id="validaRigaButton"
                        cssClass="e-flat"
                        @click.native="validaRigaClick()"
                        >Valida On/Off</ejs-button
                      >
                      <ejs-button
                        id="esportaRigaButton"
                        cssClass="e-flat"
                        @click.native="ripristinaEsportaRigaClick()"
                        >Esporta Off</ejs-button
                      >
                    </b-col>
                  </b-row>
                </b-card-body>
              </b-card>
            </b-col>
          </b-row>
        </b-tab>
      </b-tabs>
    </ejs-dialog>
  </div>
</template>

<script>
import Vue from "vue";
import useJwt from "@/auth/jwt/useJwt";
// import bootstrap-Vue
import {
  LayoutPlugin,
  CardPlugin,
  DropdownPlugin,
  AlertPlugin,
  TabsPlugin,
} from "bootstrap-vue";
// import Syncfusion
import { enableRipple } from "@syncfusion/ej2-base";
import { Query } from "@syncfusion/ej2-data";
import { ButtonPlugin } from "@syncfusion/ej2-vue-buttons";
import { DatePickerPlugin } from "@syncfusion/ej2-vue-calendars";
import { TextBoxPlugin, NumericTextBoxPlugin } from "@syncfusion/ej2-vue-inputs";
import {
  DropDownListPlugin,
  ListBoxPlugin,
  CheckBoxSelection,
} from "@syncfusion/ej2-vue-dropdowns";
import {
  GridPlugin,
  Edit as GridEdit,
  Toolbar as GridToolbar,
  Sort as GridSort,
  Filter as GridFilter,
  Aggregate,
} from "@syncfusion/ej2-vue-grids";
import { DialogPlugin } from "@syncfusion/ej2-vue-popups";

// use bootstrap-vue
Vue.use(CardPlugin);
Vue.use(LayoutPlugin);
Vue.use(TabsPlugin);
Vue.use(DropdownPlugin);
Vue.use(AlertPlugin);
// use Syncfusion
Vue.use(TextBoxPlugin);
Vue.use(NumericTextBoxPlugin);
Vue.use(DropDownListPlugin);
Vue.use(ButtonPlugin);
Vue.use(ListBoxPlugin);
Vue.use(GridPlugin);
Vue.use(DialogPlugin);
Vue.use(DatePickerPlugin);
enableRipple(true);
// api
const apiRiepilogoIncassiUrl = "/demo/api/riepilogo/ricerca";
const apiRiepilogoIncassiRicercaAnnoUrl = "/demo/api/riepilogo/ricercaAnno";
const apiBilancioCocciaRicercaAnnoUrl = "/demo/api/bilanciococcia/ricercaAnno";
const apiBilancioCocciaRiepilogoUrl = "/demo/api/riepilogo/scaricaRiepilogo";

 const apiGeneraTracciatoUrl = "/demo/api/riepilogo/genera";

 const stati = [
   { statiName: "Validato", statiId: "validato" },
   { statiName: "Da Validare", statiId: "da validare" },
   { statiName: "Esportato", statiId: "esportato" },
 ];

var fieldName;

export default Vue.extend({
  components: {},
  data() {
    return {
      anniData: [
        { label: "2021", id: "2021" },
        { label: "2022", id: "2022" },
        { label: "2023", id: "2023" },
        { label: '2024', id: '2024' },
        { label: '2025', id: '2025' },
        { label: '2026', id: '2026' },
      ],
      mesiData: [
        { label: "Gennaio", id: "01" },
        { label: "Febbraio", id: "02" },
        { label: "Marzo", id: "03" },
        { label: "Aprile", id: "04" },
        { label: "Maggio", id: "05" },
        { label: "Giugno", id: "06" },
        { label: "Luglio", id: "07" },
        { label: "Agosto", id: "08" },
        { label: "Settembre", id: "09" },
        { label: "Ottobre", id: "10" },
        { label: "Novembre", id: "11" },
        { label: "Dicembre", id: "12" },
      ],
      anniFields: { value: "id", text: "label" },
      mesiFields: { value: "id", text: "label" },
      anniIndex: -1,
      mesiIndex: -1,
      dropMesiEnabled: false,
      queryAnni: null,
      queryMesi: null,
      // generali
      settings: {
        formatoData: "dd/MM/yyyy",
        formatoOra: "HH:mm",
        intervalloOra: 15,
        listboxSelectionSettings: { showCheckbox: true },
        formatoDatepicker: "dd/MM/yyyy", // da usare per i datepicker
      },
      // mese / anno selezionati
      annoCorrente: null,
      meseCorrente: null,
      // incassiBigl
      incassiBiglFullData: [], // elenco completo dati incassiBigl
      incassiBiglActiveId: 0, // Id scrittura artistica attivo (0 se nuovo)
      incassiBiglActiveData: {}, // dati completi dell scrittura artistica attivo
      incassiBiglSavedData: {}, // dati completi dell scrittura artistica attivo
      incassiBiglDefaultData: {}, // dati completi di default per nuovi incassiBigl

      totalePreventivo: null, // leggerà da backend
      totaleConsuntivo: null,
      scostamento: null,
      raggiungimentoPerc: null,
      incassiBiglAnnui: null,

      // per alertA
      alertADismissSecs: 3,
      alertADismissCountDown: 0,

      // per dialogA
      dialogA: {
        header: "Modifica Riga",
        visible: false,
        showCloseIcon: true,
        buttons: [
          {
            click: this.dialogAOk,
            buttonModel: { content: "OK", isPrimary: true },
          },
          { click: this.dialogACancel, buttonModel: { content: "Cancel" } },
        ],
        animationSettings: { effect: "FadeZoom", duration: 400, delay: 0 }, // { effect: 'None' }, // selezionata per primo livello
        zIndex: 1050,
        tabAdialogAIndex: 0,
      },
      // per gridA
      editparams: {
        params: {
          allowFiltering: true,
          dataSource: stati,
          fields: { text: "statiName", value: "statiId" },
          query: new Query(),
          actionComplete: () => false,
          popupHeight: "400px",
        },
      },
      gridAFlag: true,
      gridA: {
        height: 300,
        editOptions: {
          allowEditing: false,
          allowDeleting: false,
        },
        filterOptions: { type: "Excel" },
        toolbarOptions: [
          {
            text: "Modifica",
            tooltipText: "Modifica Riga",
            prefixIcon: "e-expand",
            id: "edit",
          },
          "Search",
        ],
        //sortOptions: { columns: [{ field: "stato", direction: "Ascending" }] },
        sortOptions: {
          columns: [
            { field: "stato", direction: "Ascending" },
            { field: "data", direction: "Descending" },
          ],
        },
      }, //
    };
  },
  created() {
    // log
    console.log("Pagina Incassi Biglietteria Creata");
    // inizializzazione elenchi dal backend
    // chiamate API
    console.log("Recupero elenchi dal backend");

    // Recupero/definisco i valori di default delle entità utilizzate nel componente
    // TODO: spostare i valori di default in file json separato?
    // incassiBiglDefaultData
    this.incassiBiglDefaultData = {};
  },
  mounted() {
    // disabilito gridA
    this.$refs.gridA.$el.classList.add("disablegrid");
    document.getElementById("GridParent").classList.add("wrapper");
    // focus su dropAnni
    this.$refs.dropAnni.ej2Instances.focusIn();
  },

  provide: {
    // per grid
    grid: [GridToolbar, GridSort, GridFilter, GridEdit, Aggregate],
    // per listBox
    listbox: [CheckBoxSelection],
  },
  methods: {
    // per aggiornamento differenza
    onInputChange: function (e) {
      // aggiorno Differenza
      console.log("Aggiorno Differenza");
      this.incassiBiglActiveData.Differenza =
        -parseFloat(this.incassiBiglActiveData.TitoliDiaccesso) -
        parseFloat(this.incassiBiglActiveData.e_GiftCard_VoucherIncasso) +
        parseFloat(this.incassiBiglActiveData.ContanteInCassaforte) +
        parseFloat(this.incassiBiglActiveData.CartaDiCredito) +
        parseFloat(this.incassiBiglActiveData.Bancomat) +
        parseFloat(this.incassiBiglActiveData.PayPal) +
        parseFloat(this.incassiBiglActiveData.Satispay) +
        parseFloat(this.incassiBiglActiveData.Bonifico) +
        parseFloat(this.incassiBiglActiveData.BonificoOrganizzatori) +
        parseFloat(this.incassiBiglActiveData.Assegno) +
        parseFloat(this.incassiBiglActiveData.e_GiftCard_Voucher) +
        parseFloat(this.incassiBiglActiveData.I18app) +
        parseFloat(this.incassiBiglActiveData.CartaDelDocente) +
        parseFloat(this.incassiBiglActiveData.CartaCulturaMerito) +
        //parseFloat(this.incassiBiglActiveData.OnlineTotale) +
        parseFloat(this.incassiBiglActiveData.CCPNexi) +
        parseFloat(this.incassiBiglActiveData.CCPPayPal) +
        parseFloat(this.incassiBiglActiveData.PrestampaTitoli) +
        parseFloat(this.incassiBiglActiveData.Amministrativo);
      //this.incassiBiglActiveData.Differenza = this.incassiBiglActiveData.OnlineTotale - this.incassiBiglActiveData.CCPPayPal
      this.incassiBiglActiveData.Differenza =
        this.incassiBiglActiveData.Differenza.toFixed(2);
    },
    // per aggiornamento CCPNexi
    // onCCPNexiChange: function (e) {
    //   // aggiorno CCPPaypal
    //   console.log("Aggiorno CCPPaypal");
    //   this.incassiBiglActiveData.CCPPayPal =
    //     parseFloat(this.incassiBiglActiveData.OnlineTotale) -
    //     parseFloat(this.incassiBiglActiveData.CCPNexi);
    //   this.incassiBiglActiveData.CCPPayPal =
    //     this.incassiBiglActiveData.CCPPayPal.toFixed(2);
    // },
    // per aggiornamento CCPPaypal
    // onCCPPaypalChange: function (e) {
    //   // aggiorno CCPNexi
    //   console.log("Aggiorno CCPNexi");
    //   this.incassiBiglActiveData.CCPNexi =
    //     parseFloat(this.incassiBiglActiveData.OnlineTotale) -
    //     parseFloat(this.incassiBiglActiveData.CCPPayPal);
    //   this.incassiBiglActiveData.CCPNexi =
    //     this.incassiBiglActiveData.CCPNexi.toFixed(2);
    // },
    // per somma nel footer grid
    // footerSum: function () {
    //   return {
    //     template: Vue.component("sumTemplate", {
    //       template: `<span>Sum: </span>`,
    //       data() {
    //         return { data: {} };
    //       },
    //     }),
    //   };
    // },
    // per dropdownlist combinate
    onAnnoChange: function (e) {
      this.dropMesiEnabled = true;
      this.meseCorrente = null;
      // Azzero i totali
      this.totalePreventivo = null;
      this.totaleConsuntivo = null;
      this.scostamento = null;
      this.raggiungimentoPerc = null;
    },
    onMeseChange: function (e) {
      console.log(this.annoCorrente);
      console.log(this.meseCorrente);
      const datiDaInviare = {
        anno: this.annoCorrente,
        mese: this.meseCorrente,
      };
      useJwt.post(apiRiepilogoIncassiUrl, datiDaInviare).then((d) => {
        // gestione risposta
        this.incassiBiglFullData = d.data;
        this.incassiBiglFullData = [...this.incassiBiglFullData]; // trigger aggiornamento grid dopo modifica contenuto incassiBiglFullData
        // console.log("Incassi biglietteria letti");
        // console.log(this.incassiBiglFullData);
      });
      // abilito gridA
      this.$refs.gridA.$el.classList.remove("disablegrid");
      document.getElementById("GridParent").classList.remove("wrapper");
    },
    async scaricaRiepilogo(args) {
      console.log("Scarica Riepilogo")
      const r = await useJwt.post(apiBilancioCocciaRiepilogoUrl, {anno: this.annoCorrente}).then((response) => {
        if (response.statusText === "OK") {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "riepilogo.xlsx");
          document.body.appendChild(link);
          link.click();
          this.makeToast("success", "Info", "Download Riepilogo completato con successo!");
        }
      })
    },
    async aggiornaRiepilogo(args) {
      console.log("Aggiorna Riepilogo")
      const r = await useJwt.post(apiBilancioCocciaRicercaAnnoUrl, {anno: this.annoCorrente}).then((d) => {
        console.log("BILANCIO COCCIA")
        console.log(d.data)
        this.totalePreventivo += +d.data['prevRicaviBiglProd']
        this.totalePreventivo += +d.data['prevRicaviBiglCompOsp']
      })

      this.totaleConsuntivo = 0;
      const r1 = await useJwt.post(apiRiepilogoIncassiRicercaAnnoUrl, {anno: this.annoCorrente}).then((d) => {
        // gestione risposta
        // this.incassiBiglAnnui = d.data;
        // this.incassiBiglAnnui.forEach((obj) => {
        // this.totaleConsuntivo = this.totaleConsuntivo + Number(obj.TitoliDiaccesso);
        // })
        console.log(d.data)
        this.totaleConsuntivo = d.data['totale_consuntivo_anno']
        this.scostamento = this.totalePreventivo - this.totaleConsuntivo;
        if ((this.totalePreventivo > 0) && (this.totaleConsuntivo > 0)) {
          this.raggiungimentoPerc = 100*this.totaleConsuntivo/this.totalePreventivo;
        } else { this.raggiungimentoPerc = null; }
      });


    },

    dialogAOpen(args) {
      console.log("Apertura dialogA1");

      // evita chiusura dialog su pressione enter
      let dialogObj = args.element.ej2_instances[0];
      dialogObj.keyDown = this.noop.bind(this);
      dialogObj.dataBind();
    },
    dialogAClose() {
      console.log("Chiusura dialogA1");
    },
    dialogACancel() {
      console.log("Cliccato bottone Cancel di dialogA");
      this.$refs.dialogA.hide();
    },

    salvaModifiche() {
      const editUrl = `/demo/api/riepilogo/${this.incassiBiglActiveId}`;
      console.log("Dati attuali da salvare:");
      console.log(this.incassiBiglActiveData);
      useJwt.patch(editUrl, this.incassiBiglActiveData).then((res) => {
        console.log(res);
        if (res.status === 200) {
          // aggiornamento tabella con valori modificati
          const i = this.incassiBiglFullData.findIndex(
            (x) => x.id === this.incassiBiglActiveId
          );
          if (i >= 0) {
            this.incassiBiglFullData[i] = res.data;
            console.log("Dati recuperati dal salvataggio:");
            console.log(res.data);
            this.incassiBiglFullData = [...this.incassiBiglFullData];
          }
          this.makeToast("success", "Info", "Salvataggio modifiche completato");
          this.$refs.dialogA.hide();
        } else {
          this.makeToast(
            "primary",
            "Attenzione",
            "Salvataggio riga riepilogo non riuscito"
          );
        }
        this.gridAFlag = true;
      });
    },
    dialogAOk() {
      console.log("OK");
      this.salvaModifiche();
      // TODO: gestire eccezione di axios per gestire problemi di rete ed altri errori
    },
    pad(s) {
      return s < 10 ? "0" + s : s;
    },
    gridAClickHandler(args) {
      if (args.item.id === "edit") {
        console.log("aprire dialog edit");

        try {
          const selectedRow = this.$refs.gridA.getSelectedRecords();
          this.incassiBiglActiveId = selectedRow[0].id; // ZZZ
          // console.log("gridA, Id selezionato:");
          console.log(this.incassiBiglActiveId);

          const i = this.incassiBiglFullData.findIndex(
            (x) => x.id === this.incassiBiglActiveId
          );
          if (i >= 0) {
            this.incassiBiglActiveData = { ...this.incassiBiglFullData[i] };
            // conversione formato data in dd/mm/YYYY
            var d = new Date(this.incassiBiglActiveData.data);
            this.incassiBiglActiveData.data = [
              this.pad(d.getDate()),
              this.pad(d.getMonth() + 1),
              d.getFullYear(),
            ].join("/");

            console.log(this.incassiBiglActiveData);
            console.log(this.incassiBiglActiveId);

            this.$refs.dialogA.show(true);
          }
        } catch (err) {
          console.log("Occorre selezionare una riga della tabella");
          console.log(err);
          this.alertAShow();
        }
      }
    },
    validaRigaClick() {
      console.log("ID da validare");
      console.log(this.incassiBiglActiveId);

      if (this.incassiBiglActiveData.stato == "da validare") {
        this.incassiBiglActiveData.stato = "validato";
        this.incassiBiglActiveData.statoEsporta = "da esportare";
      } else if (this.incassiBiglActiveData.stato == "validato") {
        this.incassiBiglActiveData.stato = "da validare";
        this.incassiBiglActiveData.statoEsporta = "da validare";
      }
      //this.salvaModifiche();
    },
    ripristinaEsportaRigaClick() {
      console.log("ID da ripristinare esportazione");
      console.log(this.incassiBiglActiveId);

      if (
        this.incassiBiglActiveData.statoEsporta == "esportato" &&
        this.incassiBiglActiveData.stato == "validato"
      ) {
        this.incassiBiglActiveData.statoEsporta = "da esportare";
      } else if(this.incassiBiglActiveData.statoEsporta == "da esportare"){
        this.incassiBiglActiveData.statoEsporta = "non esportare"
      }
    },

    // Grid’s actionComplete event handler
    // Triggers after an action is completed
    gridAactionComplete(args) {
      if (args.requestType === "save") {
        // The flag is disabled after operation is successfully performed so that it can enter the condition on next execution
        this.gridAFlag = false;
      }
      if (args.requestType === "beginEdit") {
        // focus the column
        args.form.elements[
          this.$refs.gridA.ej2Instances.element.getAttribute("id") + fieldName
        ].focus();
        // aggiornamento dinamico valori celle
        // riesco a triggerare dei calcoli cambiando le celle di testo, ma non se cambio le colonne dropdown o checkbox
        // riesco però a leggere i valori di dropdown e checkbox, per poterli usare nel trigger di celle di testo
        // riesco ad aggiornare il valore di celle di testo, ma non di checkbox e dropdown
        var columnOnlineTotaleId = 19; //16;
        var columnOnlineNexiId = 20; //17;
        var columnOnlinePaypalId = 21; //18;
        var grid =
          document.getElementsByClassName("e-grid")[0].ej2_instances[0];
        // Gestione aggiornamenti da modifiche della colonna "Online Nexi"
        grid.editModule.formObj.element[columnOnlineNexiId].addEventListener(
          "keyup",
          function (e) {
            var totale =
              +grid.editModule.formObj.element[columnOnlineTotaleId].value; // leggo il valore della cella di testo
            var nexi =
              +grid.editModule.formObj.element[columnOnlineNexiId].value;
            //var paypal = +grid.editModule.formObj.element[columnOnlinePaypalId].value;
            var paypal = totale - nexi;
            grid.editModule.formObj.element[columnOnlinePaypalId].value =
              paypal;
            console.log(totale);
            console.log(nexi);
            console.log(paypal);
          }
        );
        // Gestione aggiornamenti da modifiche della colonna "Online Paypal"
        grid.editModule.formObj.element[columnOnlinePaypalId].addEventListener(
          "keyup",
          function (e) {
            var totale =
              +grid.editModule.formObj.element[columnOnlineTotaleId].value; // leggo il valore della cella di testo
            //var nexi = +grid.editModule.formObj.element[columnOnlineNexiId].value;
            var paypal =
              +grid.editModule.formObj.element[columnOnlinePaypalId].value;
            var nexi = totale - paypal;
            grid.editModule.formObj.element[columnOnlineNexiId].value = nexi;
            console.log(totale);
            console.log(nexi);
            console.log(paypal);
          }
        );
        this.gridAFlag = false;
      }
    },
    gridAqueryCellInfo: function (args) {
      // tolta perchè mi riaggiornava la formula
      // if (args.column.field === "totale") {
      //   var totale = args.data.compenso + args.data.costoDitta;
      //   args.data.totale = totale;          //here we have calculated the Total price and updated the value to datasource
      //   args.cell.innerText = totale;      //here we have set the Total price to the cell value for UI changes
      //}
    },
    generaTracciati: function (args) {
      let datiDaInviare = [];
      const righe = document.getElementById("gridA").ej2_instances[0].getRows();
      console.log(righe);
      righe.forEach((obj) => {
        //console.log('Riga i-esima:')
        //console.log(obj)
        if (
          obj.cells[2].outerText === "validato" &&
          obj.cells[3].outerText === "da esportare"
        ) {
          //console.log(obj.cells[0].outerText)
          datiDaInviare.push(obj.cells[0].outerText);
        }
      });

      useJwt
        .post(apiGeneraTracciatoUrl, datiDaInviare, { responseType: "blob" })
        .then((response) => {
          if (response.statusText === "OK") {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "tracciati.zip");
            document.body.appendChild(link);
            link.click();
            console.log('Aggiornamento statoEsporta in "esportato"');
            // loop per ogni data Inviata
            datiDaInviare.forEach((idDataCorrente) => {
              // loop per incassi biglietteria
              const i = this.incassiBiglFullData.findIndex((x) => x.id === idDataCorrente);
              console.log(i)
              if (i >= 0) {
                this.incassiBiglFullData[i].statoEsporta = "esportato";
              }
              this.incassiBiglFullData = [...this.incassiBiglFullData];
            });
            this.makeToast(
              "success",
              "Info",
              "Generazione tracciati completata con successo!"
            );
          } else {
            console.log("Errore nella generazione tracciati");
            this.makeToast(
              "primary",
              "Attenzione",
              "Errore nella generazione tracciati"
            );
          }
        });
    },

    // per alert
    alertACountDownChanged(alertADismissCountDown) {
      this.alertADismissCountDown = alertADismissCountDown;
    },
    alertAShow() {
      this.alertADismissCountDown = this.alertADismissSecs;
    },
    // per toast
    makeToast(variant = null, title = "titolo", message = "messaggio") {
      this.$bvToast.toast(message, {
        title,
        variant,
        solid: true,
        autoHideDelay: 10000,
      });
    },
  },
  computed: {
    hasChanged() {
      // console.log(this.incassiBiglActiveData)
      // console.log(this.incassiBiglSavedData)
      return Object.keys(this.incassiBiglActiveData).some(
        (field) =>
          this.incassiBiglActiveData[field] !== this.incassiBiglSavedData[field]
      ); // serve ancora??
    },
  },
});

/* eslint-disable global-require */
</script>

<style lang="scss">
@import "~@syncfusion/ej2-base/styles/material.css";
@import "~@syncfusion/ej2-buttons/styles/material.css";
@import "~@syncfusion/ej2-vue-buttons/styles/material.css";
@import "~@syncfusion/ej2-dropdowns/styles/material.css";
@import "~@syncfusion/ej2-vue-popups/styles/material.css";
@import "~@syncfusion/ej2-vue-navigations/styles/material.css";
@import "~@syncfusion/ej2-inputs/styles/material.css";
@import "~@syncfusion/ej2-vue-layouts/styles/material.css";
@import "~@syncfusion/ej2-splitbuttons/styles/material.css";
@import "~@syncfusion/ej2-grids/styles/material.css";
@import "~@syncfusion/ej2-vue-calendars/styles/material.css";

.e-btn-icon.e-open-icon {
  background: url("~@/assets/images/svg/open2-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-delete-icon {
  background: url("~@/assets/images/svg/garbage-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-download-icon {
  background: url("~@/assets/images/svg/download2-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-search-icon {
  background: url("~@/assets/images/svg/search-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-upload-icon {
  background: url("~@/assets/images/svg/upload-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-add-icon {
  background: url("~@/assets/images/svg/add2-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

// per disabilitare la grid
.disablegrid {
  pointer-events: none;
  opacity: 0.4;
}

.wrapper {
  cursor: not-allowed;
}
</style>
